export default __webpack_public_path__ + "static/media/upgrade.8fa140f5.png";